export default __webpack_public_path__ + "a6675b2991f94f897f6b480a9a458b17.woff2?proxy=wpt-abc";